const { protocol, host } = window.location
export default `${protocol}//${host}`
